import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"; // ⬅️ import useLocation
import { FaPhoneAlt } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import api from "../../utils/api";
import Cookies from "js-cookie";

const Footer = () => {
  const RestaurantSavedId = JSON.parse(localStorage.getItem("selectedRestaurantId"));
  const [locationData, setLocationData] = useState([]);

  const location = useLocation(); // ⬅️ get current route
  const isLandingPage = location.pathname === "/"; // check if we are at "/"

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (RestaurantSavedId) {
          const response = await api.get(`/restaurant/${RestaurantSavedId}`);
          const results = response.data?.data || [];
          setLocationData(results);
        }
      } catch (error) {
        console.error("Error fetching restaurant data:", error);
      }
    };
    fetchData();
  }, [RestaurantSavedId]);

  return (
    <footer className="bg-[rgba(239,234,215,1)] py-8">
      <div className="container mx-auto w-full lg:px-4 px-2">
        {/* If landing page → only show Support */}
        {isLandingPage ? (
          <div className="flex ">
            <div>
              <h3 className="text-[#AF313D] font-bold mb-2 lg:text-[24px] md:text-[18px] text-[15px] body">
                Support
              </h3>
              <ul className="space-y-2 text-gray-700 font-semibold">
                <li>
                  <Link to="/contact" className="hover:text-[#AF313D]">
                    Customer services
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="hover:text-[#AF313D]">
                    Email us
                  </Link>
                </li>
                <li>
                  <Link to="/privacy-policy" className="hover:text-[#AF313D]">
                    Privacy policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions" className="hover:text-[#AF313D]">
                    Terms and conditions
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        ) : (
          // Otherwise → show full footer
          <div>
            {/* Logo Section */}
            <div className="flex justify-start mb-6">
              <img
                src={locationData?.logo && locationData?.logo[0]}
                alt="Logo"
                className="lg:h-[114px] h-[73px] md:h-[81px]"
              />
            </div>

            <div className="flex md:flex-row flex-col gap-8 md:gap-12 text-center md:text-left">
              {/* Contact */}
              <div className="lg:w-[380px]">
                <h3 className="text-[#AF313D] font-bold mb-3 text-lg md:text-xl body">
                  Contact Information
                </h3>
                <p className="text-gray-700 flex items-center gap-2 mb-2">
                  <FaPhoneAlt className="text-[#AF313D]" />
                  <a href={`tel:${locationData?.phone}`} className="hover:underline">
                    {locationData?.phone}
                  </a>
                </p>
                <p className="text-gray-700 flex items-center gap-2 mb-2">
                  <IoMdMail className="text-[#AF313D]" />
                  <a href={`mailto:${locationData?.email}`} className="hover:underline">
                    {locationData?.email}
                  </a>
                </p>
                <p className="text-gray-700 flex items-center gap-2">
                  <FaLocationDot className="text-[#AF313D]" />
                  {locationData?.address}
                </p>
              </div>

              {/* Support */}
              <div>
                <h3 className="text-[#AF313D] font-bold mb-2 text-lg md:text-xl body">
                  Support
                </h3>
                <ul className="space-y-2 text-gray-700 font-semibold">
                  <li>
                    <Link to="/contact" className="hover:text-[#AF313D]">
                      Customer services
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact" className="hover:text-[#AF313D]">
                      Email us
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy" className="hover:text-[#AF313D]">
                      Privacy policy
                    </Link>
                  </li>
                  <li>
                    <Link to="/terms-and-conditions" className="hover:text-[#AF313D]">
                      Terms and conditions
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Socials */}
              <div>
                <p className="text-gray-700 font-semibold mb-2">
                  Fast food that will make you slow down
                </p>
                <p className="text-gray-500 text-sm mb-4">
                  2025 Copyright. All rights reserved
                </p>
                <div className="flex gap-4 text-[#AF313D] justify-center md:justify-start">
                  <Link to={locationData?.facebook || "#"} aria-label="Facebook">
                    <FaFacebookF className="w-6 h-6" />
                  </Link>
                  <Link to={locationData?.instagram || "#"} aria-label="Instagram">
                    <FaInstagram className="w-6 h-6" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
